import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Hardcoded admin emails - matches server.js
const ADMIN_EMAILS = [
    'bspencerhooah@gmail.com',
    // Add more admin emails here
];

function AdminRoute({ children }) {
    const { currentUser, userData, loading } = useAuth();

    if (loading) {
        return (
            <div className="admin-loading">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!currentUser) {
        return <Navigate to="/auth" replace />;
    }

    // Check hardcoded email list OR Firestore role
    const isAdminByEmail = ADMIN_EMAILS.includes(currentUser.email?.toLowerCase());
    const isAdminByRole = userData?.role && ['admin', 'super_admin'].includes(userData.role);

    if (!isAdminByEmail && !isAdminByRole) {
        return <Navigate to="/home" replace />;
    }

    return children;
}

export default AdminRoute;
